export const CORE_CARS_NAME = "core-cars";

export enum CoreCarsComponent {
  CarLocationAutocomplete = "CarLocationAutocomplete",
  CarSearch = "CarSearch",
  SearchPage = "SearchPage",
  AvailabilityPage = "AvailabilityPage",
  CarList = "CarList",
  CarListLoading = "CarListLoading",
  CarCard = "CarCard",
  CarSpecificationsSummary = "CarSpecificationsSummary",
  CarSpecificationsDialog = "CarSpecificationsDialog",
  CarAvailabilityMap = "CarAvailabilityMap",
  CarAvailabilityHeader = "CarAvailabilityHeader",
  CarAvailabilityHeaderContent = "CarAvailabilityHeaderContent",
  CarAvailabilityFilterRow = "CarAvailabilityFilterRow",
  CarListSort = "CarListSort",
  FilterDialog = "FilterDialog",
  PriceBreakdownDialog = "PriceBreakdownDialog",
  CarListStoreGroup = "CarListStoreGroup",
  StoreCardHeader = "StoreCardHeader",
  StoreMapMarker = "StoreMapMarker",
  LocationPreviewDialog = "LocationPreviewDialog",
  CarReservationCard = "CarReservationCard",
  CarReservationDetailTitle = "CarReservationDetailTitle",
  CarReservationDetailPage = "CarReservationDetailPage",
  CarReservationConfirmation = "CarReservationConfirmation",
  CarReservationDetailSummary = "CarReservationDetailSummary",
  CarReservationDriverInfo = "CarReservationDriverInfo",
  CarReservationFuelInfo = "CarReservationFuelInfo",
  CarReservationLocation = "CarReservationLocation",
  CarReservationSelfServeLinks = "CarReservationSelfServeLinks",
  CarReservationCancelPolicy = "CarReservationCancelPolicy",
  CarReservationPayment = "CarReservationPayment",
  CustomerSupportModalContent = "CustomerSupportModalContent",
  CustomerSupportModal = "CustomerSupportModal",
  ResendEmailModal = "ResendEmailModal",
  CancelCarModal = "CancelFlightModal",
  CarDescription = "CarDescription",
  CarTimeAndDateInfo = "CarTimeAndDateInfo",
  PaymentSummaryLineItem = "PaymentSummaryLineItem",
  CarDateRangePicker = "CarDateRangePicker",
  CarDropoffTypePicker = "CarDropoffTypePicker",
  HomePageCarSearch = "HomePageCarSearch",
  CarAttributePill = "CarAttributePill",
  CarShopSection = "CarShopSection",
  VendorMessages = "VendorMessages",
  CarPickupDropoffLocation = "CarPickupDropoffLocation",
  CarPriceDisplay = "CarPriceDisplay",
  ShopPage = "ShopPage",
  CarAvailabilityCard = "CarAvailabilityCard",
  CarAvailabilityLink = "CarAvailabilityLink",
  CarShopBookingSection = "CarShopBookingSection",
  FilterPrice = "FilterPrice",
  FilterCancellation = "FilterCancellation",
  FilterBags = "FilterBags",
  FilterPassenger = "FilterPassenger",
  FilterList = "FilterList",
  FilterCarType = "FilterCarType",
  FilterSpecification = "FilterSpecification",
  FilterSuppliers = "FilterSuppliers",
  CarListError = "CarListError",
  CarsListNoItems = "CarsListNoItems",
  Filters = "Filters",
  CarAvailabilitySearch = "CarAvailabilitySearch",
  CarPriceBreakdown = "CarPriceBreakdown",
  CarCheckoutCard = "CarCheckoutCard",
  CarCheckoutDateRange = "CarCheckoutDateRange",
  ConfirmationPage = "ConfirmationPage",
  PickupPill = "PickupPill",
  CancellationPill = "CancellationPill",
  CancellationPolicySection = "CancellationPolicySection",
  CarBreadcrumbs = "CarBreadcrumbs",
}
